/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>banner配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">
      <el-form-item prop="id" label="ID">
        <el-input   oninput="if(value.length > 3) value=value.slice(0, 3)" type="number"  clearable v-model="formInline.id" placeholder="请输入ID"></el-input>
      </el-form-item>
     
      <el-form-item prop="status" label="状态 ">
    <el-select v-model="formInline.status" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="启用" value="1"></el-option>
      <el-option label="停用" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="addressType" label="展示位置 ">
    <el-select v-model="formInline.addressType" placeholder="不限">
        <el-option label="不限" value=""></el-option>
      <el-option label="首页banner" value="1"></el-option>
      <el-option label="会员中心banner" value="2"></el-option>
      <el-option  label="单身联谊banner" value="3"></el-option>
      <el-option  label="活动banner" value="4"></el-option>
      <el-option  label="婚恋服务banner" value="5"></el-option>
      <el-option  label="形象打造banner" value="6"></el-option>
      <el-option  label="关于我们banner" value="7"></el-option>
      <el-option  label="脱单故事banner" value="8"></el-option>
      <el-option  label="月娘资讯banner" value="9"></el-option>

    </el-select>
  </el-form-item>
 












    
<el-form-item prop="createBeginTime"  label="创建时间">
    <el-col :span="11">
      <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.createBeginTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-form-item  prop="createEndTime">
        <el-date-picker  default-time="['23:59:59']"  value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.createEndTime" style="width: 100%;"></el-date-picker>
      </el-form-item>
   

    </el-col>
  </el-form-item>
    <el-form-item>
      <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button  icon="el-icon-delete"  type="info"    @click="resetForm('formInline')">重置</el-button>
      <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
    </el-form-item>

  

<div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">

          <el-button  type="success" icon="el-icon-plus" @click="handleEdit() ">添加</el-button>
       
        </div> 
    </el-form> 
<el-table id="educe-table"  ref="multipleTable"     stripe :data="listData" highlight-current-row v-loading="loading"
  
  @select-all="selectall"  @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">
    <el-table-column  prop="orders"  align="center"  label="排序"  width="100">
      <template slot-scope="scope">
           <span style="color: blueviolet; font-size: 28px;">{{ scope.row.orders }}</span>
</template>
    </el-table-column>
    <el-table-column  prop="id"  align="center"  label="ID"  width="100">
    </el-table-column>
    <el-table-column     prop="headIcon" label="头像" width="160">

<template slot-scope="scope">
  <el-image 
style="width: 100px; height: 100px;"
:src="scope.row.path"

:preview-src-list="[scope.row.path]"/>
</template>
</el-table-column>
   
<el-table-column  prop="title"    label="标题" width="200">
    </el-table-column>

   

    <el-table-column  prop="statusDesc"   align="center" label="状态" width="100">

      <template slot-scope="scope">
        <el-tag v-if="scope.row.statusDesc=='启用'"  type="success">启用</el-tag>
      <el-tag v-if="scope.row.statusDesc=='停用'" type="danger">停用</el-tag>
      </template>
      
      
    </el-table-column>
    <el-table-column  prop="addressTypeDesc" align="center"  label="banner位置" width="150">


 
    
      
     
    </el-table-column>
    <el-table-column  prop="version"   align="center" label="开始/结束时间" >
      <template slot-scope="scope">
        <div>{{scope.row.beginTimeMills|timestampToTime}}</div><br>
        <div>{{scope.row.endTimeMills|timestampToTime}}</div>
      </template>
    </el-table-column>

    <el-table-column fixed="right"  align="center" prop="version" label="操作" width="150">
      <template slot-scope="scope">
        <el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"  type="primary">编辑</el-button>
      </template>
    </el-table-column>
    

    <!-- <el-table-column align="center" label="操作" min-width="300">
      <template slot-scope="scope">
        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column> -->
  </el-table>

    <!--列表-->
   
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm"   style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"  @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

    <el-dialog :title="title"  ref="editForm" :destroy-on-close="true"  center :visible.sync="editFormVisible" width="80%"   @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
          
        <el-form-item label="展示位置" prop="addressType" > 
          <el-radio-group @input="oninput" v-model="editForm.addressType">
          <el-radio  label="1">首页banner</el-radio>
          <el-radio  label="2">会员中心banner</el-radio>
          <el-radio  label="3">单身联谊banner</el-radio>
          <el-radio  label="4">活动banner</el-radio>
          <el-radio  label="5">婚恋服务banner</el-radio>
          <el-radio  label="6">形象打造banner</el-radio>
          <el-radio  label="7">关于我们banner</el-radio>
          <el-radio  label="8">脱单故事banner</el-radio>
          <el-radio  label="9">月娘资讯banner</el-radio>
          
        </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input maxlength="10" style="width: 300px;"  v-model="editForm.title" auto-complete="off" placeholder="请输入10个中文字以内"></el-input>
        </el-form-item>
       
        <el-form-item label="图片" prop="path">
          <el-upload 
          :limit='1'
          :class="{ disabled: uploadDisabled }" 
         
  :action=ssoServerimg
  list-type="picture-card"
  tokenId:this.adder
  :before-upload="beforeUpload"
  :file-list="fileList"
  :on-change="uploadSectionFile"
  :on-preview="handlePictureCardPreview"
  :on-success="handleAvatarSuccess"

  :on-remove="handleRemove">
  
  <i class="el-icon-plus"></i>
</el-upload>

<span style="color: red;">建议尺寸：{{ formstle }}</span>
        </el-form-item>
        <el-form-item  v-if="indexs==2" label="状态" prop="status">
          <el-radio v-model="editForm.status" label="1">启用</el-radio>
          <el-radio v-model="editForm.status" label="2">停用</el-radio>
        </el-form-item>
        <el-form-item  label="是否支持跳转" prop="type">
          <el-radio v-model="editForm.type" label="1">是</el-radio>
          <el-radio v-model="editForm.type" label="2">否</el-radio>
        </el-form-item>
        <el-form-item  v-if="editForm.type==1"   label="参数链接" prop="url">
          <el-input   v-model="editForm.url"  style="width: 300px;" auto-complete="off" placeholder="请输入参数链接"></el-input>
        </el-form-item>
     
        <el-form-item  label="开始时间" prop="beginTime">
        <el-date-picker
       
      v-model="editForm.beginTime"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
      v-model="editForm.endTime"
      
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
        </el-form-item>
        <el-form-item label="排序" prop="orders">
          <el-input  type="number"  style="width: 300px;" v-model="editForm.orders" auto-complete="off" placeholder="请输入排序"></el-input>
        </el-form-item>
       
       
      </el-form>

        
        
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog('editForm ')">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>




    <el-dialog :visible.sync="dialogVisibleimg">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
 
</div>
</template>

<script>

import { deptList, deptSave,deptDelete} from '../../api/userMG'
import * as imageConversion from 'image-conversion';
import Axios from 'axios'
import { login } from "../../api"
let tokenId= localStorage.getItem('tokenId');
import Vue from 'vue'

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      file_list:[],
      hideUpload: false,
      formstle:"",
      ssoServer:"",
      adewer:"",
     
      dialogVisibles:false,
      forlist:'',
      dialogVisibleimg:false,
      dialogImageUrl: '',
      ifSgowm:1,
        dialogVisible: false,
        
        uploadDisabled:false,
        hideUpload_introduce: false,
limitCount: 1,
        indexs:"",
        formInline: {
            isPC:1,
            addressType:"",         
          platformType:'',
          title:"",
          status:"",
          createBeginTime:"",
          createEndTime:"",
          id:"",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn:false,
      activeName: '1',
      userlist:"",
      radio:"",
      cityOptions:[{
        name:"审核未通过",
        lis:-1,

      },{
        name:"10",
        lis:10,

      },{
        name:"20",
        lis:20,

      },{
        name:"30",
        lis:30,

      },{
        name:"40",
        lis:40,

      },{
        name:"50",
        lis:50,

      },{
        name:"60",
        lis:60,

      },{
        name:"70",
        lis:70,

      },{
        name:"80",
        lis:80,

      },{
        name:"90",
        lis:90,

      },{
        name:"100",
        lis:100,

      }],
      dialogFormVisible:false,
      checkList: [],
      options123 : [],
      undataList:"",
      ssoServerimg:"",
      options1234123:[],
      fileList:[],
      
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加banner',
      options: [{
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        },{
          value: 6,
          label: '博士后'
        },{
          value: 7,
          label: '博士后'
        }],
        source:[{
          value: 1,
          label: '网站注册'

        },{
          value: 2,
          label: '人工录入'

        },{
          value: 3,
          label: '资源导入'

        },{
          value: 4,
          label: '相亲活动'

        },{
          value: 5,
          label: '手机来电'

        },{
          value: 6,
          label: '表单填写'

        },{
          value: 7,
          label: '到店咨询'

        }],
      editForm: {
        appId:"",
        correlationAtlasId:'',//关联图集id
        id:"",
        status:"",
        addressType:"",
        addDeer:"",
        platformType:[3],
        url:"",
        title:"",
        beginTime:"",
        type:"",
        path:[],
        orders:"",
        deptId: '',
        endTime:"",
      },
     
      // rules表单验证
      rules: {
        platformType: [{ required: true, message: '展示平台不能为空', trigger: 'blur' }],
        
        addDeer: [
          { required: true, message: '请选择位置', trigger: 'blur' }
        ],
        
        addressType: [{ required: true, message: '展示位置不能为空', trigger: 'blur' }],
        correlationAtlasId: [{ required: true, message: '请输入关联图集id', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        path: [{ required: true, message: '请选择图片', trigger: 'blur' }],
        type: [{ required: true, message: '请选择是否支持跳转', trigger: 'blur' }],
        
        beginTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
        endTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
        orders: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
        url: [{ required: true, message: '参数链接不能为空', trigger: 'blur' }],
        appId: [{ required: true, message: '小程序appid不能为空', trigger: 'blur' }]
        
        
        
        
      },
      adder:"",
      
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },
  
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServerimg=Vue.prototype.GLOBAL.ssoServerimg
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId

    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    // this.getAddress()
    // this.getAddresss()
    // this.ongetAddress()

   
   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {



    beforeUpload(file) {
      const _that = this
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJpgOrPng) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      return new Promise((resolve) => {
        // 小于2M 不压缩
         if (isLt2M) {
          resolve(file)
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then((res) => {
          resolve(res);
        });
      
      });
    },

    oninput(e){
      if(e==1){
        this.formstle ='750px*480px'
        this.ifSgowm=1
      }else{
        this.ifSgowm=2
        this.formstle ='750px*1404px'
      }
      // console.log(e);
    },
    uploadSectionFile(f,g){
      if (g.length >= 1) {
      this.uploadDisabled = true;
    }
     

      this.hideUpload = true;
    },
    
    handleAvatarSuccess(res, file) {

        this.editForm.path = res.data
        this.hideUpload = false;
      },

    // 删除图片
    handleRemove(file, fileList) {
      this.editForm.path = ''
      this.uploadDisabled = false;
       
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
       this.dialogVisibleimg=true
      },
    //添加
  
    // 确定审核
    OndialogVisible(){

        Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-nick-name-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
        //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,
         
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogVisible=false
          this.$message({
         type: 'success',
         message: '审核成功'
       })
       this.formLIst()
    }
})
     


       

    },
  // 查看历史图片
  historyHeadIcons(item){
    this.historyHea =item
    // console.log(item);
    this.dialogFormVisibleicn=true

  },
    // 颜值打分
    YZdialogFormVisible(){
      if(!this.radio){
        this.$message({
         type: 'warning',
         message: '选择不能为空'
       })
       return
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
          appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,
         
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
         type: 'success',
         message: '打分成功'
       })
       this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange(){
      console.log(this.checkList);
    },
    caozClick(){
      if(this.importList.length==0){
        this.$message({
         type: 'warning',
         message: '请选择要审核的用户'
       })
       return

      }else{
        this.dialogVisible=true
        console.log('1111');
      }

    },
    
    handleClick(tab, event) {
    //  return  console.log(this.activeName);
     if(this.activeName==1){
      this.formInline.status=1
        this.formLIst()
     }else if(this.activeName==2){
      this.formInline.status=2
        this.formLIst()
     }else if(this.activeName==3){
      this.formInline.status=3
        this.formLIst()
     }
    
      },

    getAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },

    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },

    handleEdit(index, row) {
      
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.indexs =2
        this.fileList=[];
        this.fileList.push({
          'url': row.path  
        })

      this.uploadDisabled = true;
      if(row.addressType==1){
        this.formstle ='750px*480px'
        this.ifSgowm=1
      }else{
        this.ifSgowm=2
        this.formstle ='750px*1404px'
      }
        // console.log(index,row);
        this.title = '编辑banner'
        this.editForm.addressType=String(row.addressType)
        this.editForm.id =row.id
        this.editForm.url =row.url
        this.editForm.status = String(row.status)
        this.editForm.title = row.title

        
        let addlist =[]
        row.platformType.forEach(element => {
     addlist.push(String(element))
        });
        this.editForm.platformType=addlist
       
        this.editForm.correlationAtlasId=row.correlationAtlasId
        this.editForm.addDeer = row.addDeer
        this.editForm.type = String(row.type)
        this.editForm.beginTime = row.beginTime
        this.editForm.orders = row.orders
        this.editForm.path =row.path
        this.editForm.appId =row.appId

        this.editForm.deptId = row.deptId
        this.editForm.endTime =row.endTime
       
      } else {
        this.indexs =1
        this.uploadDisabled = false;
        this.editForm.url=''

        this.title = '添加banner'
        this.fileList=[]
        this.editForm.platformType=[3]
        this.editForm.addDeer = ''
        this.editForm.addressType=''
        this.editForm.type = ''
        this.editForm.correlationAtlasId = ''
        this.editForm.beginTime = ''
        this.editForm.orders = ''
        this.editForm.deptId = ''
        this.editForm.endTime = ''
        this.editForm.title = ''
        this.editForm.appId =''
      }
    },
    addOnclick(index,row){
      this.editFormVisible=true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑banner'
        this.editForm.roleId = row.roleId
        this.editForm.systemNo = row.systemNo
        this.editForm.roleNo = row.roleNo
        this.editForm.roleName = row.roleName
      } else {
        this.title = '添加banner'
        this.editForm.roleId = ''
        this.editForm.systemNo = ''
        this.editForm.roleNo = ''
        this.editForm.roleName = ''
        this.editForm.appId =''
      }
      // this.indexs=1
      // if (this.indexs==1) {
      //   this.title='添加banner'
      //   this.editFormVisible=true
      // }
     
    },
    selectalls(rows) {
      this.userlist =rows
      this.indexs=2
      if (this.indexs==2) {
        this.title='编辑banner'

        let add = String(rows.type)
      //  return  console.log(add);
      
      this.editFormVisible=true
      this.editForm =this.userlist
      this.editForm.type=add
      this.editForm
      }
    
      // this.undataList =rows
      
   console.log(rows);
    },


              onChange(e){
              
                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);
                

              },
              onChanges(e){
                this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    selectall(val){
        console.log(val);

      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })
      
      // this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      if(this.importList.length==0){
       
       this.$message({
         type: 'warning',
         message: '请选择要导出的数据'
       })
       return
    
     }else{
             Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/exportExcel',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importList
 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = res.headers['content-disposition'].split('filename=')[1]
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})


     }
    



    },
    select(selection, row){
     
      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })
      
      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
        this.$refs[formInline].resetFields();
      },


    formLIst(){
      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'/api//platform-banner/listByPlatform',
  headers:{
    tokenId:this.adder
        },
  params:this.formInline
}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){
		
		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
       
      }
      this.loading = false
      
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
        // .then(res => {
        //   console.log(res);
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.listData = res.data
        //     // 分页赋值
        //     this.pageparm.currentPage = this.formInline.current
        //     this.pageparm.pageSize = this.formInline.size
        //     this.pageparm.total = res.count
        //   }
        // })
        // .catch(err => {
        //   this.loading = false
        //   this.$message.error('菜单加载失败，请稍后再试！')
        // })
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage
      
      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
this.formLIst()
      
      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    // handleEdit: function(index, row) {
    //   this.editFormVisible = true
    //   if (row != undefined && row != 'undefined') {
    //     this.title = '修改'
    //     this.editForm.deptId = row.deptId
    //     this.editForm.deptName = row.deptName
    //     this.editForm.deptNo = row.deptNo
    //   } else {
    //     this.title = '添加'
    //     this.editForm.deptId = ''
    //     this.editForm.deptName = ''
    //     this.editForm.deptNo = ''
    //   }
    // },
    // 编辑、增加页面保存方法
    submitForm(editForm) {
      this.$refs[editForm].validate((valid) => {
          if (valid) {


            const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          if(this.indexs==1){

Axios({
method: 'post',
url: this.ssoServer+'/api/platform-banner/add',
headers:{
tokenId:this.adder
},
data: this.editForm
}).then(res=>{
if(res.data.code==999){
setTimeout(() => {
localStorage.removeItem('tokenId')

this.$store.commit('logout', 'false')
this.$router.push({ path: '/login' })
this.$message({
type: 'success',
message: '登录过期,请重新登录'
})
}, 1000)
}
if(res.data.code==0){
this.editFormVisible=false
this.$message({
type: 'success',
message: '添加成功'
})

this.formLIst()

}else{
  this.$message({
type: 'warning',
message: res.data.message
})
}
// console.log(res);
})

}else{
Axios({
method: 'post',

url: this.ssoServer+'/api/platform-banner/edit',
headers:{
tokenId:this.adder
},
data: this.editForm
}).then(res=>{
if(res.data.code==999){
setTimeout(() => {
localStorage.removeItem('tokenId')

this.$store.commit('logout', 'false')
this.$router.push({ path: '/login' })
this.$message({
type: 'success',
message: '登录过期,请重新登录'
})
}, 1000)
}
if(res.data.code==0){

this.editFormVisible=false
this.$message({
type: 'success',
message: '修改成功'
})

this.formLIst()

}else{
  this.$message({
type: 'warning',
message: res.data.message
})
}
// console.log(res);
})





console.log('编辑');
}
loading.close();
        }, 500);



           
           
          } else {
          
          }
        });
    
    },
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      this.fileList=[]
      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
    }
  }
}
</script>

<style>


.disabled .el-upload--picture-card {
  display: none !important;
}




.dialogForm{
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .dialogFormChl{
    margin-top: 20px;
    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }
  .dialogFormChl img{
   width: 100%;
   height: 200px;
  }
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/officialWebsite/bannerList.vue